import { AddressInformation } from "./address-detail-info";

export class BillingInformation {
    address: AddressInformation;
    cardType: String;
    cardNumber: String;
    expireDate: String;
    expiryMonth: String;
    expiryYear :String;
    maskedCard : String;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/billing-info.ts